import React, { Component } from "react";

import Modal from "../common/components/Modal";
import ContactForm from "./ContactForm";

import { contactUs } from "../webAPI/MKSService";

const initialState = {
	subject: "expansion",
	message: "",
	error: "",
	isSending: false
};

class ContactFormContainer extends Component {
	constructor(props) {
		super(props);
		this.state = initialState;

		this.handleSubjectChange	= this.handleSubjectChange.bind(this);
		this.handleMessageChange	= this.handleMessageChange.bind(this);
		this.handleSubmit			= this.handleSubmit.bind(this);
		this.resetForm				= this.resetForm.bind(this);
	}

	render() {
		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnClickOutside
				closeOnEsc
				onClose={this.props.onClose}>
				<ContactForm
					{...this.state}
					handleSubjectChange={this.handleSubjectChange}
					handleMessageChange={this.handleMessageChange}
					handleSubmit={this.handleSubmit}
					handleCancel={this.resetForm}/>
			</Modal>
		);
	}

	handleSubjectChange(subject) {
		this.setState({ subject });
	}

	handleMessageChange(event) {
		this.setState({ message: event.target.value });
	}

	handleSubmit() {
		const message = this.state.message;
		if(!message) {
			this.setState({
				error: "Décrivez votre demande"
			});
			return;
		}

		this.setState({ isSending: true })
		contactUs(this.props.projectId, this.state.subject, this.state.message).then(
			(error) => {
				this.setState({ isSending: false });
			},
			(result) => {
				this.setState({ isSending: false });
				this.resetForm();
			}
		);
	}

	resetForm() {
		this.props.onClose();
		this.setState({ ...initialState });
	}
}

export default ContactFormContainer;



// WEBPACK FOOTER //
// ./src/js/project-v2/ContactFormContainer.js